module.exports = __webpack_public_path__ + "media/images/icons/success_email-c4d0cefbd385aa3df8c1a811537bd92e.svg";